import React, { useRef, useState, useEffect } from "react";
import "./bookslots.css";
import BackIcon from "../../../Assets/Icons/BackIcon";
import NavbarCustom from "../../../Components/NavbarCustom";
import { Calendar } from "primereact/calendar";
import { useSession } from "../../../APIContext/SessionContext";
import { usePlayerAccount } from "../../../APIContext/PlayerAccountContext";
import { useMOU } from "../../../APIContext/MOUContext";
import { useLocation, useNavigate } from "react-router-dom";
import "remixicon/fonts/remixicon.css";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import Swal from "sweetalert2";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { TextField } from "@mui/material";

export const BookSlots = () => {
  const toast = useRef(null);
  const {
    location,
    fetchLocation,
    fetchPackages,
    fetchSportEvents,
    checkBookingEvents,
    confirmBookingEvents,
  } = useSession();
  const user = JSON.parse(localStorage.getItem("user"));
  const self_pay = user?.is_self_pay !== undefined ? user?.is_self_pay : true;
  const { fetchParentPlayers, loading } = usePlayerAccount();
  const { checkMOUStatus } = useMOU();

  const navigate = useNavigate();
  const [sportEvents, setSportEvents] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [selectedAvailable, setSelectedAvailable] = useState([]);
  const [selectedEventDetails, setSelectedEventDetails] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [error, setError] = useState("");
  const [parentPlayers, setParentPlayers] = useState([]);
  const params = new URLSearchParams(window.location.search);
  const sportId = params.get("sport_id");
  const saleId = params.get("sale_id");
  const sporttype = params.get("type");
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [note, setNote] = useState("");

  function getLocalTime(utcDateTime) {
    const localDate = new Date(utcDateTime);
    return localDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  function getLocalDate(utcDateTime) {
    const localDate = new Date(utcDateTime);
    return localDate.toLocaleDateString([], {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }

  function getLocalDay(utcDateTime) {
    const localDate = new Date(utcDateTime);
    return localDate.toLocaleDateString([], {
      weekday: "long",
    });
  }

  function to24HourFormat(dateObj) {
    if (!dateObj) return "";
    const hours = String(dateObj.getHours()).padStart(2, "0");
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  }

  const [filters, setFilters] = useState({
    location: "",
    date: "",
    start_time: "",
    end_time: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchSportEvents(
          sportId,
          saleId,
          "",
          "",
          "",
          "",
          timeZone,
          "",
          sporttype,
        );

        await fetchLocation();
        setSportEvents(data || []);
        const players = await fetchParentPlayers(saleId);
        setParentPlayers(players);
      } catch (err) {
        console.error("Error fetching initial data:", err);
      }
    };
    fetchData();
  }, [sportId, saleId]);

  const applyFilters = async () => {
    const formattedStart = filters.start_time
      ? to24HourFormat(filters.start_time)
      : "";
    const formattedEnd = filters.end_time
      ? to24HourFormat(filters.end_time)
      : "";

    const data = await fetchSportEvents(
      sportId,
      saleId,
      filters.location || "",
      filters.date || "",
      formattedStart,
      formattedEnd,
      timeZone,
      "",
      sporttype,
    );
    setSportEvents(data);
  };

  const handleCheckboxChange = (eventId) => {
    setSelectedAvailable((prev) =>
      prev.includes(eventId)
        ? prev.filter((id) => id !== eventId)
        : [...prev, eventId],
    );
  };

  const handleProceed = async () => {
    if (!selectedPlayer) {
      Swal.fire({
        icon: "warning",
        title: "Please Select The Child",
        confirmButtonText: "OK",
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
      return;
    }

    const userDetails = JSON.parse(localStorage.getItem("user"));
    let selectedEvents = {};
    if (userDetails.is_self_pay === true) {
      selectedEvents = {
        event_ids: selectedAvailable,
        sale_id: saleId,
        player_id: selectedPlayer,
        type: sporttype,
      };
    } else {
      selectedEvents = {
        event_ids: selectedAvailable,
        sport_id: Number(sportId),
        player_id: selectedPlayer,
        type: sporttype,
      };
    }

    const bookingData = await checkBookingEvents(selectedEvents);
    if (bookingData && bookingData.possible === true) {
      setSelectedEventDetails(bookingData.events || []);
      setShowPopup(true);
      setError("");
    } else if (bookingData?.error) {
      setSelectedEventDetails([]);
      setError("");
      setShowPopup(false);
    }
  };

  const handleBooking = async () => {
    let selectedEvents = {
      event_ids: selectedAvailable,
      sale_id: Number(saleId),
      player_id: selectedPlayer,
      type: sporttype,
      sport_id: Number(sportId),
      notes: note,
    };
    await confirmBookingEvents(selectedEvents);
    fetchPackages();
    setShowPopup(false);

    navigate(`/confirm-booking?sport_id=${sportId}&sale_id=${saleId}`);
  };

  const handlePlayerChange = async (e) => {
    const playerId = e.value;

    const data = await fetchSportEvents(
      sportId,
      saleId,
      "",
      "",
      "",
      "",
      timeZone,
      playerId,
      sporttype,
    );
    if (!data || data.length === 0) {
      Swal.fire({
        title: "Warning",
        text: "There are no events available at this time for this sport and booking type",
        icon: "warning",
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
      return;
    }
    setSportEvents(data || []);

    const userData = JSON.parse(localStorage.getItem("user"));
    if (userData.is_self_pay === false) {
      try {
        const response = await checkMOUStatus(playerId);
        if (response.status === "mou_exists") {
          setSelectedPlayer(playerId);
          return;
        } else {
          const result = await Swal.fire({
            icon: "warning",
            title: response.message,
            confirmButtonText: "Add MOU Now",
            confirmButtonColor: "#B79527", // orange / gold
            cancelButtonColor: "#1C1C1C",
          });
          if (result.isConfirmed) {
            navigate(`/mou-form?player_id=${playerId}`);
          }
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while checking MOU status.",
          confirmButtonColor: "#B79527", // orange / gold
          cancelButtonColor: "#1C1C1C",
        });
      }
    } else {
      setSelectedPlayer(playerId);
    }
  };

  const closePopup = () => setShowPopup(false);

  function formatTime(time) {
    const [hours, minutes] = time.split(":").map(Number);
    let suffix = hours >= 12 ? "P.M." : "A.M.";
    let adjustedHours = hours % 12 || 12;
    return `${String(adjustedHours).padStart(2, "0")}:${String(
      minutes,
    ).padStart(2, "0")} ${suffix}`;
  }

  function formatDate(dateStr) {
    const [year, month, day] = dateStr.split("-");
    return `${month}-${day}-${year}`;
  }

  function calculateAge(dob) {
    if (!dob) return ``;
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    if (age === 0) {
      return ``;
    }
    return `(${age} yo)`;
  }

  return (
    <>
      <Toast ref={toast} />
      <NavbarCustom />
      <div className="buy-packages-sports-container book-slot">
        <div className="buy-packages-header">
          <BackBtn
            navigateTo={
              self_pay ? `/session-sports?type=1-1` : `/list-of-sports`
            }
          />
          <div className="buy-packages-header-content">
            <h1 className="buy-packages-heading black-text-clip">
              Choose Your Preferred Location, Date & Time
            </h1>
          </div>
        </div>

        <div className="book-slots-container">
          <div className="select-child-section">
            <label className="black-text-clip" htmlFor="childSelect">
              Select Your Child
            </label>
            <Dropdown
              value={selectedPlayer}
              // onChange={(e) => setSelectedPlayer(e.value)}
              onChange={handlePlayerChange}
              options={
                parentPlayers.map((player) => ({
                  label: `${player.name} ${calculateAge(player.date_of_birth)}`,
                  value: player.id,
                })) || []
              }
              placeholder={loading ? "Loading children..." : "Select Child"}
              className="w-full md:w-14rem drop-down-selectchild"
              disabled={loading}
            />
          </div>

          <div className="select-child-section">
            <label className="black-text-clip" htmlFor="childSelect">
              Notes (Optional)
            </label>
            <textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Enter any additional information or requests..."
            />
          </div>

          <div className="book-slots-header">
            <div className="book-slots-header-left">
              <h2 className="black-text-clip">List of Events</h2>
            </div>
            <div className="book-slots-header-right">
              <button
                className="filter-button-slots"
                onClick={() => setShowFilters(!showFilters)}
              >
                <span className="black-text-clip">Filter By</span>
                <i
                  style={{ width: "20%" }}
                  className={`ri-arrow-${showFilters ? "up" : "down"}-s-line black-text-clip`}
                ></i>
              </button>
            </div>
          </div>

          {showFilters && (
            <div className="filter-dropdown">
              <div className="filter-dropdown-header">
                <h3 className="black-text-clip">Filters</h3>
                <button
                  className="filter-close-button"
                  onClick={() => setShowFilters(false)}
                >
                  <i className="ri-close-line"></i>
                </button>
              </div>

              <div className="filter-field">
                <label className="black-text-clip">Location</label>
                <select
                  value={filters.location}
                  onChange={(e) =>
                    setFilters({ ...filters, location: e.target.value })
                  }
                >
                  <option value="">Select Location</option>
                  {location &&
                    location.map((loc) => (
                      <option key={loc.id} value={loc.id}>
                        {loc.name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="filter-field">
                <label className="black-text-clip">Date</label>
                <Calendar
                  value={filters.date ? new Date(filters.date) : null}
                  onChange={(e) => {
                    if (e.value) {
                      const d = e.value;
                      const localDate =
                        d.getFullYear() +
                        "-" +
                        String(d.getMonth() + 1).padStart(2, "0") +
                        "-" +
                        String(d.getDate()).padStart(2, "0");

                      setFilters({ ...filters, date: localDate });
                    } else {
                      setFilters({ ...filters, date: "" });
                    }
                  }}
                  dateFormat="mm-dd-yy"
                  placeholder="mm-dd-yyyy"
                  showIcon
                />
              </div>

              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <div className="filter-field">
                  <label className="black-text-clip">
                    Time Slot (Start Time)
                  </label>
                  <TimePicker
                    ampm
                    value={filters.start_time}
                    onChange={(newValue) =>
                      setFilters({ ...filters, start_time: newValue })
                    }
                    renderInput={(params) => (
                      <TextField {...params} fullWidth />
                    )}
                  />
                </div>

                <div className="filter-field">
                  <label className="black-text-clip">
                    Time Slot (End Time)
                  </label>
                  <TimePicker
                    ampm
                    value={filters.end_time}
                    onChange={(newValue) =>
                      setFilters({ ...filters, end_time: newValue })
                    }
                    renderInput={(params) => (
                      <TextField {...params} fullWidth />
                    )}
                  />
                </div>
              </LocalizationProvider>

              <div className="filter-field">
                <button
                  className="apply-filters-button"
                  onClick={(e) => {
                    e.preventDefault();
                    applyFilters();
                    setShowFilters(!showFilters);
                  }}
                >
                  Apply Filters
                </button>
              </div>
            </div>
          )}

          <div className="book-slots-body">
            {/* available events */}
            {sportEvents &&
              sportEvents?.map((event) => {
                return (
                  <div
                    key={event.id}
                    className="book-slots-body-item available-events"
                  >
                    <div className="check-box">
                      <div className="checkbox-container">
                        <input
                          type="checkbox"
                          name={`event_${event.id}`}
                          key={event.id}
                          checked={selectedAvailable.includes(event.id)}
                          onChange={() => handleCheckboxChange(event.id)}
                        />
                      </div>
                    </div>

                    <div className="check-box-content">
                      <div className="name-container">
                        <p className="black-text-clip">
                          {event.name}, {event?.location}
                        </p>
                      </div>
                      <div className="day-container">
                        <p>
                          <span className="black-text-clip">
                            {getLocalDay(event?.start_datetime_utc)}
                          </span>
                        </p>
                      </div>
                      <div className="date-container">
                        <p>
                          <span className="black-text-clip">
                            {getLocalDate(event?.start_datetime_utc)}
                          </span>
                        </p>
                      </div>
                      <div className="time-container">
                        <p>
                          <span className="black-text-clip">{`${getLocalTime(event?.start_datetime_utc)} - ${getLocalTime(event?.end_datetime_utc)}`}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>

        <div className="p-submit-button-container">
          <button
            type="button"
            disabled={selectedAvailable.length === 0}
            className="p-submit-button"
            onClick={handleProceed}
          >
            Proceed with Selected Items ({selectedAvailable.length})
          </button>
        </div>

        {showPopup && (
          <div className="book-popup-overlay">
            <div className="book-popup-content">
              <h2>Your Chosen Items Are</h2>
              <div className="popup-list">
                <h3>Basketball</h3>
                {selectedEventDetails.length > 0 ? (
                  selectedEventDetails.map((event, index) => {
                    return (
                      <div key={event.id} className="popup-item">
                        <span>
                          {index + 1}) {event.name}
                        </span>
                        <span>{getLocalDay(event.start_time_utc)}</span>
                        <span>{`${getLocalTime(event.start_time_utc)} - ${getLocalTime(event.end_time_utc)}`}</span>
                        <span>{getLocalDate(event.start_time_utc)}</span>
                      </div>
                    );
                  })
                ) : (
                  <p>{error}</p>
                )}
              </div>
              <div className="popup-buttons">
                <button onClick={closePopup} className="go-back-button">
                  Go Back
                </button>
                {error === "" && (
                  <button
                    className="book-sessions-button"
                    onClick={handleBooking}
                  >
                    Book Your Sessions
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
